<template>
  <div class="details__content__score is-flex is-align-items-center">
    <span :class="`${pillColor} u-border-radius--tiny`">{{ score }}</span>
    <div class="is-flex is-flex-direction-column">
      <span class="u-weight--bold">{{ $t(reviewLabel) }} </span>
      <span v-if="this.amount > 1">
        ({{ $t("reviewCount", getReviewCount()) }})
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewsSummary",
  props: {
    score: String,
    amount: Number
  },
  computed: {
    pillColor() {
      const s = parseFloat(this.score);
      if (s >= 9) return "pill--dark-green";
      if (s > 7) return "pill--green";
      if (s >= 6) return "pill--orange";
      if (s >= 1) return "pill--red";
      return "pill--grey";
    },
    reviewLabel() {
      const s = parseFloat(this.score);
      if (s >= 9) return "reviews.reallyGood";
      if (s > 7) return "reviews.good";
      if (s >= 6) return "reviews.average";
      if (s >= 1) return "reviews.bad";
      return "noReviews";
    }
  },
  methods: {
    getReviewCount() {
      const reviewCount = this.formatNumber(this.amount);
      return { count: this.amount, numberOfReviews: reviewCount };
    }
  }
};
</script>
